/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { HomepageDashboard } from '../model';
// @ts-ignore
import { InsightsDashboard } from '../model';
// @ts-ignore
import { SummaryDashboard } from '../model';
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
export const DashboardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets an Insights dashboard
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsDashboard: async (dashboardId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getInsightsDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/insights/{dashboardId}`
                .replace(`{${"dashboardId"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Old /insights/dashboards?dashboard= and /insights/reports?report= links carry the id the dashboard had in the legacy insight_dashboard table. To be removed in 27R1.
         * @summary Resolves an old Insights link to its dashboard
         * @param {number} legacyId The dashboard\&#39;s legacy insight_dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsDashboardByLegacyId: async (legacyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'legacyId' is not null or undefined
            assertParamExists('getInsightsDashboardByLegacyId', 'legacyId', legacyId)
            const localVarPath = `/dashboards/insights/legacy/{legacyId}`
                .replace(`{${"legacyId"}}`, encodeURIComponent(String(legacyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the summary dashboard for an entity
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryDashboard: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getSummaryDashboard', 'entityId', entityId)
            const localVarPath = `/dashboards/summary/entities/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets homepage dashboards for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserHomepageDashboards: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboards/homepage/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardsApi - functional programming interface
 * @export
 */
export const DashboardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets an Insights dashboard
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsightsDashboard(dashboardId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsightsDashboard(dashboardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Old /insights/dashboards?dashboard= and /insights/reports?report= links carry the id the dashboard had in the legacy insight_dashboard table. To be removed in 27R1.
         * @summary Resolves an old Insights link to its dashboard
         * @param {number} legacyId The dashboard\&#39;s legacy insight_dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsightsDashboardByLegacyId(legacyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsightsDashboardByLegacyId(legacyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the summary dashboard for an entity
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryDashboard(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryDashboard(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets homepage dashboards for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserHomepageDashboards(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomepageDashboard>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserHomepageDashboards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardsApi - factory interface
 * @export
 */
export const DashboardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets an Insights dashboard
         * @param {number} dashboardId Dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsDashboard(dashboardId: number, options?: any): AxiosPromise<InsightsDashboard> {
            return localVarFp.getInsightsDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Old /insights/dashboards?dashboard= and /insights/reports?report= links carry the id the dashboard had in the legacy insight_dashboard table. To be removed in 27R1.
         * @summary Resolves an old Insights link to its dashboard
         * @param {number} legacyId The dashboard\&#39;s legacy insight_dashboard ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsightsDashboardByLegacyId(legacyId: number, options?: any): AxiosPromise<InsightsDashboard> {
            return localVarFp.getInsightsDashboardByLegacyId(legacyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the summary dashboard for an entity
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryDashboard(entityId: number, options?: any): AxiosPromise<SummaryDashboard> {
            return localVarFp.getSummaryDashboard(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets homepage dashboards for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserHomepageDashboards(options?: any): AxiosPromise<Array<HomepageDashboard>> {
            return localVarFp.getUserHomepageDashboards(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
export class DashboardsApi extends BaseAPI {
    /**
     * 
     * @summary Gets an Insights dashboard
     * @param {number} dashboardId Dashboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getInsightsDashboard(dashboardId: number, options?: any) {
        return DashboardsApiFp(this.configuration).getInsightsDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Old /insights/dashboards?dashboard= and /insights/reports?report= links carry the id the dashboard had in the legacy insight_dashboard table. To be removed in 27R1.
     * @summary Resolves an old Insights link to its dashboard
     * @param {number} legacyId The dashboard\&#39;s legacy insight_dashboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getInsightsDashboardByLegacyId(legacyId: number, options?: any) {
        return DashboardsApiFp(this.configuration).getInsightsDashboardByLegacyId(legacyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the summary dashboard for an entity
     * @param {number} entityId Entity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getSummaryDashboard(entityId: number, options?: any) {
        return DashboardsApiFp(this.configuration).getSummaryDashboard(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets homepage dashboards for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    public getUserHomepageDashboards(options?: any) {
        return DashboardsApiFp(this.configuration).getUserHomepageDashboards(options).then((request) => request(this.axios, this.basePath));
    }
}
